/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React, {memo, useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AlertNotification} from '@ion/core/src/types/entities';
import {ViewAlertNotifications} from '@ion/dls/src/editors/ViewAlertNotifications';
import {viewAlertsNotification} from '../alertsNotifications/state';
import {
  viewNotificationEventIsEditingSelector,
  viewNotificationEventIsLoadingSelector,
  viewNotificationEventSelectedSelector
} from '../alertsNotifications/state-selectors';
import {viewAlertConfiguration} from './state';
import {
  adminDevicesViewAlertConfigIsEditingSelector,
  adminDevicesViewAlertConfigLoadingSelector,
  adminDevicesViewAlertConfigResultSelector,
  adminDevicesViewAlertConfigSelectedSelector
} from './state-selectors';
import ViewAlertConfigEditor from './ViewAlertConfigEditor';

interface ViewDeviceAlertDialogProp {
  enabled?: boolean;
}

/**
 * Re-usable component for displaying the view a device event details dialog.
 */
export const ViewDeviceAlertDialogs = ({enabled}: ViewDeviceAlertDialogProp) => {
  const dispatch                  = useDispatch();
  const showAlertConfig           = useSelector(adminDevicesViewAlertConfigIsEditingSelector);
  const selectedAlertConfig       = useSelector(adminDevicesViewAlertConfigSelectedSelector);
  const alertConfigData           = useSelector(adminDevicesViewAlertConfigResultSelector);
  const loadingAlertConfig        = useSelector(adminDevicesViewAlertConfigLoadingSelector);
  const selectedNotificationAlert = useSelector(viewNotificationEventSelectedSelector);
  const isLoadingAlert            = useSelector(viewNotificationEventIsLoadingSelector);
  const showAlertNotification     = useSelector(viewNotificationEventIsEditingSelector);

  const onViewAlertConfigClose = useCallback(() => {
    dispatch(viewAlertConfiguration(null, false));
  }, []);

  const onViewAlertClose = useCallback(() => {
    dispatch(viewAlertsNotification(null, false));
  }, []);

  if (enabled) {
    return (
      <>
        {(showAlertConfig && selectedAlertConfig) && (
          <ViewAlertConfigEditor open
            loading={loadingAlertConfig}
            alertConfigData={alertConfigData}
            onCloseDialog={onViewAlertConfigClose} />
        )}
        {(showAlertNotification && selectedNotificationAlert) && (
          <ViewAlertNotifications open
            loading={isLoadingAlert}
            notification={selectedNotificationAlert as AlertNotification}
            onCloseDialog={onViewAlertClose} />
        )}
      </>
    );
  }
};

export default memo(ViewDeviceAlertDialogs);
